<template>
  <transition name="fade">
    <div class="spinner-box" v-if="showMask">
      <div class="click-mask"></div>
      <div :class="{ bg: showBg }" v-if="spinnerShow">
        <div class="spinner-container1" v-if="picSpinner">
          <div class="spinner1"></div>
        </div>
        <div class="spinner-container2" v-if="!picSpinner">
          <div class="spinner2"></div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "spinner",
  data() {
    return {
      spinnerShow: false,
      showMask: false,
      timer: null,
    };
  },
  props: {
    showBg: {
      type: Boolean,
      default: true,
    },
    picSpinner: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hide() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.$nextTick(() => {
        this.spinnerShow = false;
        this.showMask = false;
      });
    },
    show(immediate = false) {
      this.showMask = true;
      if (immediate) {
        this.$nextTick(() => {
          this.spinnerShow = true;
        });
      } else {
        this.timer = setTimeout(() => {
          this.spinnerShow = true;
        }, 1000);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.spinner-box {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9998;
  width: 100%;
  height: 100%;
  max-width: none !important;
  .click-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .bg {
    width: 100%;
    height: 100%;
    background: rgba(#000, 0.4);
  }

  .spinner-container1 {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    width: 1.75rem;
    height: 1.827rem;
  }
  .spinner1 {
    @include bgImg("root/loading_pet.png");
    position: absolute;
    top: 0;
    left: 0;
    width: 1.75rem;
    height: 1.827rem;
    transform-origin: 1.75rem 2.61rem;
    animation: horizontal_shake 0.5s linear infinite;
  }

  .spinner-container2 {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    width: 0.6rem;
    height: 0.6rem;
  }
  .spinner2 {
    @extend .icon-loading;
    position: absolute;
    top: 0;
    left: 0;
    animation: infinite_rotate 1s linear infinite;
  }
}
</style>